import api from "@helpers/api";

import { STATUS } from "@constants/status.hrm";
import { URLS } from "@constants/urls";

import { PaginationRequestType } from "@type/HRM/pagination";
import { TicketSettingsType } from "@type/tickets/ticket-settings";

const { SETTINGS } = URLS;
const { SUCCESS, FAILED } = STATUS;

const apiEndPoint = `${process.env.REACT_APP_E_TICKETING_SERVICE_BASE_URL}${process.env.REACT_APP_E_TICKETING_SERVICE_PORT}/${process.env.REACT_APP_E_TICKETING_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${SETTINGS}`;

export const getTicketDropdown = (() => {
  return async (url: string) => {
    return api
      .get(`${apiEndPoint}/${url}?page=1&size=1000`)
      .then((response) => response.data.data);
  };
})();

export const getTicketSettingsList = (() => {
  return async (url: string, data: PaginationRequestType) => {
    const { page, size, search } = data;

    return api
      .get(`${apiEndPoint}/${url}`, {
        params: {
          page,
          size,
          search,
        },
      })
      .then((response) => {
        const { data, page, size, total } = response.data;

        return {
          data,
          pagination: {
            page,
            size,
            total,
          },
        };
      });
  };
})();

export const addNewETicketSettings = (() => {
  return async (
    url: string,
    formData: TicketSettingsType,
    afterEffect: (param: any) => void
  ) => {
    return api
      .post(`${apiEndPoint}/${url}`, {
        ...formData,
      })
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const deleteETicketSettings = (() => {
  return async (url: string, id: number, afterEffect: (param: any) => void) => {
    return api
      .delete(`${apiEndPoint}/${url}/${id}`)
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const updateETicketSettings = (() => {
  return async (
    url: string,
    id: number,
    formData: TicketSettingsType,
    afterEffect: (param: any) => void
  ) => {
    return api
      .put(`${apiEndPoint}/${url}/${id}`, {
        ...formData,
      })
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();
